import { render, staticRenderFns } from "./LobbyGameRow.vue?vue&type=template&id=74c2731c&lang=pug&"
import script from "./LobbyGameRow.vue?vue&type=script&lang=js&"
export * from "./LobbyGameRow.vue?vue&type=script&lang=js&"
import style0 from "./LobbyGameRow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
